import { jsx as _jsx } from "react/jsx-runtime";
import { VideoDisplay } from './VideoDisplay';
export function VideoOverlayDisplay({ fit, children, orientToScreen, }) {
    return (_jsx(VideoDisplay, { fit: fit, orientToScreen: orientToScreen, hud: children }));
}
